/* eslint-disable */
const isWebComponent = APP_TYPE === 'webcomponent';
let tooltipContainer = 'body';
if (isWebComponent) {
	let wcWrapper = document.getElementById('tgt');
	if (wcWrapper) {
		tooltipContainer = wcWrapper;
		console.log('tgt is the wrapper');
	}
	let telecomWcWrapper = document.getElementById('tgt-telecom-comparison');
	if (telecomWcWrapper) {
		tooltipContainer = telecomWcWrapper; // document.querySelector('wlb-telecom').shadowRoot.querySelector("div")
	}
	let internetWcWrapper = document.getElementById('tgt-internet-comparison');
	if (internetWcWrapper) {
		tooltipContainer = internetWcWrapper; // document.querySelector('wlb-telecom').shadowRoot.querySelector("div")
	}
	let comparisonWrapper = document.getElementById('tgt-comparison');
	if (comparisonWrapper) {
		tooltipContainer = comparisonWrapper; // document.querySelector('wlb-telecom').shadowRoot.querySelector("div")
	}
	let businessWcWrapper = document.getElementById('tgt-comparison-business');
	if (businessWcWrapper) {
		tooltipContainer = businessWcWrapper; // document.querySelector('wlb-telecom').shadowRoot.querySelector("div")
	}

	let inputwidgetWcWrapper = document.getElementById('tgt-input-widget');
	if (inputwidgetWcWrapper) {
		tooltipContainer = inputwidgetWcWrapper; // document.querySelector('wlb-telecom').shadowRoot.querySelector("div")
	}
	let topWidgetWcWrapper = document.getElementById('tgt-top-widget');
	if (topWidgetWcWrapper) {
		tooltipContainer = topWidgetWcWrapper; // document.querySelector('wlb-telecom').shadowRoot.querySelector("div")
	}
	let verticalWidgetWcWrapper = document.getElementById('tgt-vertical-widget');
	if (verticalWidgetWcWrapper) {
		tooltipContainer = verticalWidgetWcWrapper; // document.querySelector('wlb-telecom').shadowRoot.querySelector("div")
	}
}
module.exports = {
	defaultBoundariesElement: tooltipContainer, //document.body,
	defaultTrigger: 'click hover',
	defaultContainer: tooltipContainer,
	defaultTargetClass: 'wlb-has-tooltip',
	defaultTargetClass: 'wlb-has-tooltip',
	disposeTimeout: 2000,
	defaultPopperOptions: {
		defaultTrigger: 'click hover'
	},
	tooltip: {
		defaultTrigger: 'click hover'
	},

	defaultHtml: true,
	// Default HTML template of the tooltip element
	// It must include `tooltip-arrow` & `tooltip-inner` CSS classes (can be configured, see below)
	// Change if the classes conflict with other libraries (for example bootstrap)
	defaultTemplate:
		'<div class="wlb-tooltip" role="tooltip"><div class="wlb-tooltip-arrow"></div><div class="wlb-tooltip-inner"></div></div>',
	// Selector used to get the arrow element in the tooltip template
	defaultArrowSelector: '.wlb-tooltip-arrow, .wlb-tooltip__arrow',
	// Selector used to get the inner content element in the tooltip template
	defaultInnerSelector: '.wlb-tooltip-inner, .wlb-tooltip__inner'
};
